import { render, staticRenderFns } from "./PoliciesFormCreate.vue?vue&type=template&id=545ae874&"
import script from "./PoliciesFormCreate.vue?vue&type=script&lang=js&"
export * from "./PoliciesFormCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports